import { Box, styled, Tooltip, tooltipClasses, TooltipProps, Typography } from "@mui/material";
import { Moon, Sun, Sunrise } from "lucide-react";

import "./Calendar.scss";

export const StyleToolTip = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip
		{...props}
		classes={{ popper: className }}
	/>
))(({ theme }) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: "white",
	},

	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: "white",
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: "3px 1px 30px -2px rgba(0,0,0,0.24)",
		fontSize: 11,
	},
}));

export default function CustomTooltip({
	morningCounting,
	afternoonCounting,
	nightCounting,
}: {
	morningCounting: number;
	afternoonCounting: number;
	nightCounting: number;
}) {
	return (
		<Box className="tooltip">
			<Box className="tooltip__shift">
				<Sunrise />
				<Typography className="tooltip__shift__label">Matutino</Typography>
				<Typography className="tooltip__shift__counting">{morningCounting}</Typography>
			</Box>
			<Box className="tooltip__shift">
				<Sun />
				<Typography className="tooltip__shift__label">Vespertino</Typography>
				<Typography className="tooltip__shift__counting">{afternoonCounting}</Typography>
			</Box>
			<Box className="tooltip__shift">
				<Moon />
				<Typography className="tooltip__shift__label">Nocturno</Typography>
				<Typography className="tooltip__shift__counting">{nightCounting}</Typography>
			</Box>
		</Box>
	);
}
